import { Box, CircularProgress, Typography, styled } from '@material-ui/core';
import React, { FC, ReactNode } from 'react';

const StyledLoadingContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '200px',
  flexDirection: 'column',
  gap: '16px',
});

type LoadingContainerProps = {
  label?: string;
  children?: ReactNode;
};

export const Loading: FC<LoadingContainerProps> = ({ label, children }) => (
  <StyledLoadingContainer>
    <CircularProgress size={40} />
    {!!label && (
      <Typography variant="body2" color="textSecondary">
        {label}
      </Typography>
    )}
    {children}
  </StyledLoadingContainer>
);
